// extracted by mini-css-extract-plugin
export default {"ColorPicker":"styles_ColorPicker__UWv5s","ColorPicker__container":"styles_ColorPicker__container__KUZ4p","ColorPicker__popover":"styles_ColorPicker__popover__hot5P"};